module.exports = __webpack_public_path__ + "static/img/products application_cooler4.392cca7c.jpg";